import { setRange } from './helpers';

export const setBedroomsCount = setRange('bedroom_total');
